// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';
import gsap from 'gsap';

const fragments = {
  toggler: '[data-fragment="menuToggler"]',
  sectionToggler: '[data-fragment="sectionToggler"]',
  asideMenuContainer: '[data-fragment="asideMenuContainer"]'
};

export default class AsideNav extends WebComponent{

  constructor(props){
    super(props);
    this.state = {
      menuOpened: false,
      listOpening: false
    }
  }

  didMount() {
    this.on('click', fragments.toggler, this.handleMenuToggle);
    this.on('click', fragments.sectionToggler, this.handleSectionToggle);
    this.asideMenuContainer = document.body.querySelector(fragments.asideMenuContainer);
  }

  handleMenuToggle = (e) => {
    !this.state.menuOpened ? this.setState({menuOpened: true}) : this.setState({menuOpened: false});
  }

  handleSectionToggle = (e) => {
    let target = e.currentTarget;
    if(!target.classList.contains('open')){
      target.classList.add('open');
      gsap.to(target.previousElementSibling, {rotation:180});
      gsap.fromTo(target.nextElementSibling, {opacity: 0, y:-20}, {opacity: 1, y:0, duration: 0.25, ease: "power3.out"});
    } else {
      target.classList.remove('open');
      gsap.to(target.previousElementSibling, {rotation:0});
    }
  }

  update() {
    const { menuOpened } = this.state;
    if(menuOpened){
      this.element.classList.add("aside-nav--open");
      gsap.fromTo(".aside-nav__content", {opacity: 0, x:-88}, {opacity: 1, x:0, duration: 0.35, ease: "power3.out"});
    } else {
      gsap.to(".aside-nav__content", {opacity: 0, x:-88, duration: 0.25});
      this.element.classList.remove("aside-nav--open");
    }
    classNames(this.asideMenuContainer, { 'menu-opened': menuOpened });
  }



}






// WEBPACK FOOTER //
// ./fe/web-prefa/src/js/components/AsideNav.js